import { createContext } from "preact";

export const OrganizationContext = createContext({ loading: true });
export const CurrentUserContext = createContext({ internalId: null });
export const MessagesContext = createContext({ messages: [] });
export const RoomsContext = createContext({ rooms: [] });
export const UsersStatusContext = createContext({});



// WEBPACK FOOTER //
// ./contexts/index.js